import "svg-dataset-polyfill";
import "svg-classlist-polyfill";

if (!SVGElement.prototype.contains)
  SVGElement.prototype.contains = HTMLDivElement.prototype.contains;

// Overwrites native 'children' prototype.
// Adds Document & DocumentFragment support for IE9 & Safari.
// Returns array instead of HTMLCollection.
(function (constructor) {
  if (constructor && constructor.prototype && constructor.prototype.children == null) {
    Object.defineProperty(constructor.prototype, "children", {
      get() {
        let i = 0;
        let node;
        const nodes = this.childNodes;
        const children = [];

        while ((node = nodes[i++])) {
          if (node.nodeType === 1) {
            children.push(node);
          }
        }
        return children;
      },
    });
  }
})(window.Node || window.Element);
